import React, {Component} from 'react';
import PropTypes from 'prop-types';

class POICost extends Component {
  constructor(props) {
    super();
  }

  render() {
    let maxCost = 4;
    const currentCost = this.props._source.cost,
          subtractCost = maxCost - currentCost;

    const activeCostSign = (
      [...Array(currentCost)].map((i) =>
        <div className="poi-details__prices-sign active" key={i} />
      )
    )

    const passiveCostSign = (
      [...Array(subtractCost)].map((i) =>
        <div className="poi-details__prices-sign" key={i} />
      )
    )

    let cost = [];
    cost.push(activeCostSign, passiveCostSign);

    return (
      <div className="sk-hits-list-hit__cost">
        {cost}
      </div>
    )
  }
}

POICost.propTypes = {
  _source: PropTypes.shape({
    cost: PropTypes.number
  })
};

export default POICost;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/POIListItems/POICost.jsx